/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReloadIcon = /*#__PURE__*/ createSvgIcon(
  'ReloadIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M14.5 5.5V2h1v4.5H11v-1h3.5z" />
            <path d="M11.723 2.683A5.08 5.08 0 008.104 1.5L8.07 1l-.01.5A6.44 6.44 0 001.5 7.996v.016A6.34 6.34 0 007.988 14.5H8c2.797 0 4.405-1.384 5.334-2.777a8.234 8.234 0 001.163-2.754 3.3 3.3 0 00.008-.042l.002-.009L15 9l.493.083v.002l-.001.005-.003.017a5.109 5.109 0 01-.057.267 9.232 9.232 0 01-1.266 2.904c-1.07 1.605-2.961 3.22-6.16 3.222A7.34 7.34 0 01.5 7.996 7.44 7.44 0 018.058.5a6.08 6.08 0 016.44 5.45l-.995.1a5.08 5.08 0 00-1.78-3.367z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M18.5 6.5V3h1v4.5H15v-1h3.5z" />
            <path d="M10.085 1.5A8.5 8.5 0 001.5 10v.004A8.43 8.43 0 009.996 18.5H10c3.306 0 5.423-1.644 6.732-3.309a11.32 11.32 0 001.697-3.058 6.448 6.448 0 00.086-.257l.004-.012v-.002L19 12c.482.137.482.138.481.138v.002l-.002.006-.006.019a7.26 7.26 0 01-.102.304 12.316 12.316 0 01-1.853 3.34c-1.44 1.834-3.823 3.69-7.515 3.691A9.43 9.43 0 01.5 9.998 9.5 9.5 0 0110.09.5a9.02 9.02 0 018.646 6.352l-.955.296a8.02 8.02 0 00-7.69-5.648L10.09 1l-.005.5z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.5 7.51V3h1v5.51H18v-1h4.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.607 1.5A10.05 10.05 0 002.5 11.507a10.14 10.14 0 007.89 9.735l.012.003a9.95 9.95 0 0012.112-7.36l.973.23a10.951 10.951 0 01-13.323 8.101A11.14 11.14 0 011.5 11.517v-.009A11.05 11.05 0 0112.61.5a10.43 10.43 0 0110.008 7.352l-.956.296a9.43 9.43 0 00-9.05-6.648L12.61 1l-.003.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ReloadIcon;
